import React, { useEffect, useState, useRef } from 'react';

import { FormControl, MenuItem, Select, TextField } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import moment from 'moment';
import Button from 'components/CustomButtons/Button.js';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { v4 as uuidv4 } from 'uuid';

import { AccountBalanceWallet, AddCircle, Close } from '@material-ui/icons';
import { WithApp } from 'contexts/appContext';

const useStyles = makeStyles({
  table: {
    minWidth: 1100
  },
  grid: {
    fontWeight: 'bold',
    textAlign: 'end'
  },
  div: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignContent: 'space-around',
    flexWrap: 'nowrap',
    alignItems: 'baseline'
  },
  totalPay: {
    marginRight: '10px',
    fontSize: '17px'
  },
  input: {
    fontWeight: 'bold'
  }
});

export default WithApp(function Check(props) {
  const classes = useStyles();
  const formRef = useRef();

  const {
    banks,
    type,
    amountPay,
    dataPayment,
    showNotify,
    methodPay,
    handleMethod,
    processPayment
  } = props;

  const [totalChecks, setTotalChecks] = useState(amountPay);
  const [payment, setPayment] = useState(0);

  const columns = [
    { field: 'DueDate', type: 'date', width: 200, header: 'Fecha Vto.' },
    { field: 'CheckSum', type: 'number', width: 200, header: 'Importe' },
    { field: 'BankCode', type: 'text', width: 200, custom: true, header: 'Banco' },
    { field: 'CheckNum', type: 'number', width: 200, header: '# Cheque' }
  ];
  const [checks, setChecks] = useState([
    {
      id: uuidv4(),
      DueDate: moment().add(1, 'days').format('YYYY-MM-DD'),
      CheckSum: amountPay.toFixed(2),
      BankCode: '02',
      CheckNum: ''
    }
  ]);

  function addRow() {
    let data = {
      id: uuidv4(),
      DueDate: moment().add(1, 'days').format('YYYY-MM-DD'),
      CheckSum: 0,
      BankCode: '02',
      CheckNum: ''
    };
    setChecks([...checks, data]);
  }

  const handleChangeRow = (e, id) => {
    //actualizando la propiedad de pago.
    let objIndex = checks.findIndex((obj) => obj.id == id);
    checks[objIndex][e.target.name] = e.target.value;
    setTotalChecks(checks.reduce((sum, item) => sum + parseFloat(item.CheckSum), 0));
  };

  function deleteRow(id) {
    checks.splice(
      checks.findIndex((x) => x.id == id),
      1
    );
    setChecks([...checks]);
  }

  function getDataForm(form) {
    let dataForm = {};
    for (let input of form.current.querySelectorAll('[name]')) {
      dataForm[input.name] = input.value;
    }
    return dataForm;
  }

  function groupData() {
    let data = { ...getDataForm(formRef), checks: checks };
    if (payment > 0) {
      if (totalChecks.toFixed(2) != payment.toFixed(2)) {
        showNotify('La suma de los cheches no coincide con el monto a pagar', 'info');
      } else {
        handleMethod(type, true);
        processPayment(type, data);
      }
    } else {
      if (parseFloat(totalChecks.toFixed(2)) != parseFloat(amountPay.toFixed(2))) {
        /* console.log(parseFloat(totalChecks.toFixed(2)), parseFloat(amountPay.toFixed(2))); */
        showNotify('La suma de los cheches no coincide con la suma de los documentos', 'info');
      } else {
        handleMethod(type, true);
        processPayment(type, data);
      }
    }
  }

  return (
    <>
      <GridItem xs={12} style={{ marginBottom: '15px' }}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            groupData();
          }}
          ref={formRef}
        >
          <GridContainer>
            {/* <GridItem xs={12} md={3} lg={3}>
              <TextField
                key={methodPay[type]}
                label="Cuenta de mayor"
                type="number"
                name="CheckAcct"
                fullWidth
                defaultValue={dataPayment[type]?.CheckAcct || '10321001'}
                margin="normal"
                required
                inputProps={{
                  min: 0
                }}
                disabled
              />
            </GridItem> */}
            <GridItem xs={12} md={3} lg={3} className={classes.grid}>
              <TextField
                key={amountPay}
                name="CheckSum"
                label="Total a pagar"
                type="number"
                fullWidth
                defaultValue={dataPayment[type]?.CheckSum || amountPay.toFixed(2)}
                onChange={(e) => setPayment(parseFloat(e.target.value))}
                margin="normal"
                onKeyPress={(e) => {
                  var key = window.event ? e.which : e.keyCode;
                  if (key === 101) {
                    return e.preventDefault();
                  }
                }}
                inputProps={{
                  min: 0,
                  step: 0.0001
                }}
                required
                disabled={methodPay[type]}
              />
            </GridItem>
            <GridItem xs={12} md={3} lg={6} style={{ display: 'flex', alignItems: 'flex-end' }}>
              {methodPay[type] === false ? (
                <Button
                  key={methodPay[type]}
                  type="submit"
                  color={props.themeContext.buttonColor}
                  size="sm"
                >
                  <AccountBalanceWallet />
                  Agregar
                </Button>
              ) : (
                <Button
                  key={methodPay[type]}
                  color={props.themeContext.buttonColorDanger}
                  size="sm"
                  onClick={() => {
                    handleMethod(type, false);
                    processPayment(type, getDataForm(formRef));
                  }}
                >
                  <Close />
                  Quitar
                </Button>
              )}
            </GridItem>
          </GridContainer>
        </form>
      </GridItem>
      <GridItem xs={12}>
        <TableContainer component={Paper}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell style={{ paddingBottom: '5px', paddingTop: '5px' }} width={100}>
                  <AddCircle
                    style={{ color: '#4caf50', cursor: 'pointer' }}
                    fontSize="large"
                    onClick={() => {
                      if (methodPay[type] === false) {
                        addRow();
                      }
                    }}
                  />
                </TableCell>
                {columns.map((item, i) => {
                  return (
                    <TableCell key={i} width={item.width}>
                      {item.header}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {checks.map((objCheck, i) => {
                return (
                  <TableRow key={i}>
                    <TableCell>
                      {i + 1}
                      <Button
                        justIcon
                        round
                        simple
                        color={props.themeContext.buttonColorDanger}
                        onClick={() => deleteRow(objCheck.id)}
                        disabled={methodPay[type]}
                      >
                        <Close />
                      </Button>
                    </TableCell>
                    {columns.map((itemColum, i) => {
                      return (
                        <TableCell key={i}>
                          {itemColum.custom ? (
                            <FormControl fullWidth size="small" disabled={methodPay[type]}>
                              <Select
                                defaultValue="02"
                                inputProps={{
                                  name: 'BankCode',
                                  onChange: (e) => {
                                    handleChangeRow(e, objCheck.id);
                                  }
                                }}
                              >
                                {banks.map((bank, i) => {
                                  return (
                                    <MenuItem value={bank.BankCode} key={i}>
                                      {bank.BankName}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          ) : (
                            <TextField
                              key={checks + amountPay}
                              name={itemColum.field}
                              defaultValue={
                                itemColum.type === 'date'
                                  ? objCheck[itemColum.field] || moment().format('YYYY-MM-DD')
                                  : objCheck[itemColum.field]
                              }
                              inputProps={{
                                min:
                                  itemColum.type === 'date'
                                    ? moment().add(1, 'days').format('YYYY-MM-DD')
                                    : 0,
                                step: 0.0001
                              }}
                              size="small"
                              type={itemColum.type}
                              fullWidth
                              onChange={(e) => {
                                handleChangeRow(e, objCheck.id);
                              }}
                              onKeyPress={(e) => {
                                var key = window.event ? e.which : e.keyCode;
                                if (key === 101) {
                                  return e.preventDefault();
                                }
                              }}
                              disabled={methodPay[type]}
                            />
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </GridItem>
    </>
  );
});
